import React from 'react';
export const DEFAULT_FORMS_CONTEXT_VALUE = {};
export const FormsContext = React.createContext(DEFAULT_FORMS_CONTEXT_VALUE);
